module.exports = __webpack_public_path__ + "static/img/hainan-digital-trade.5540e53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/hainan-digital-trade.png
// module id = iGwW
// module chunks = 1 2